"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRangeSlider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_forms_1 = require("@carvana/helios-forms");
var test_attributes_1 = require("@carvana/test-attributes");
var styled_components_1 = __importDefault(require("styled-components"));
var RenderSliderInputs_1 = require("./RenderSliderInputs");
var RenderSublabels_1 = require("./RenderSublabels");
var utils_1 = require("./utils");
var SliderWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .slider__root {\n    width: 100%;\n    margin: 16px 0 8px;\n  }\n"], ["\n  .slider__root {\n    width: 100%;\n    margin: 16px 0 8px;\n  }\n"])));
var InputRangeSlider = function (props) {
    var className = props.className, _a = props.format, format = _a === void 0 ? 'number' : _a, testId = props.testId, _b = props.max, propsMax = _b === void 0 ? 100 : _b, _c = props.min, propsMin = _c === void 0 ? 0 : _c, _d = props.step, step = _d === void 0 ? 1 : _d, _e = props.value, sliderValue = _e === void 0 ? [] : _e, _f = props.onValueChange, onValueChange = _f === void 0 ? utils_1.noop : _f, _g = props.onValueCommit, onValueCommit = _g === void 0 ? utils_1.noop : _g, _h = props.labels, labels = _h === void 0 ? [] : _h, _j = props.disabled, disabled = _j === void 0 ? false : _j, _k = props.debounceDelay, debounceDelay = _k === void 0 ? 500 : _k;
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    var dataTestId = "".concat((testId && "".concat(testId, "-")) || '', "slider");
    var min = typeof propsMin === 'number' ? propsMin : propsMin.value;
    var max = typeof propsMax === 'number' ? propsMax : propsMax.value;
    var mask = (0, utils_1.maskValue)(format);
    var validateValue = function (value, updateIndex) {
        if (updateIndex === 0) {
            return (0, utils_1.clamp)(value, [min, sliderValue[1] || max]);
        }
        return (0, utils_1.clamp)(value, [sliderValue[0] || min, max]);
    };
    var getDebouncedValue = function (updateIndex) { return function (nextValue) {
        var demaskedValue = (0, utils_1.toSafeDecimalPlace)((0, utils_1.ensureNumber)((0, utils_1.demaskValue)(nextValue), updateIndex === 0 ? min : max), step);
        var validated = validateValue(demaskedValue, updateIndex);
        var nextSliderValue = __spreadArray([], sliderValue, true);
        nextSliderValue[updateIndex] = validated;
        onValueChange(nextSliderValue);
        onValueCommit(nextSliderValue);
    }; };
    var internalLabels = sliderValue.map(function (value, index) { return (__assign({ value: mask(value), onChange: getDebouncedValue(index) }, labels[index])); });
    var getSublabelMinMax = function () { return ({
        min: typeof propsMin === 'number' ? mask(propsMin) : __assign(__assign({}, propsMin), { value: mask(propsMin.value) }),
        max: typeof propsMax === 'number' ? mask(propsMax) : __assign(__assign({}, propsMax), { value: mask(propsMax.value) })
    }); };
    return ((0, jsx_runtime_1.jsxs)(SliderWrapper, __assign({}, getTestAttributes('slider-composite'), { className: className, "data-testid": dataTestId }, { children: [(0, jsx_runtime_1.jsx)(RenderSliderInputs_1.RenderSliderInputs, { labels: internalLabels, disabled: disabled, delay: debounceDelay }), (0, jsx_runtime_1.jsx)(helios_forms_1.Slider, __assign({}, props, { max: max, min: min, value: sliderValue, onValueCommit: onValueCommit, onValueChange: onValueChange })), (0, jsx_runtime_1.jsx)(RenderSublabels_1.RenderSublabels, __assign({}, getSublabelMinMax()))] })));
};
exports.InputRangeSlider = InputRangeSlider;
var templateObject_1;
